<ng-container *transloco="let t">
  @let isMobile = !!(isMobileMode || (isMobile$ | async));
  <pxc-sequence-preview-tile-media-carousel
    class="mb-2"
    [clientCode]="sequence.clientCode"
    [medias]="sequence.medias"
    [sequenceId]="sequence.sequenceInstance.id"
    [showActions]="showActions"
    (mediaClicked)="mediaClicked.emit($event)">
    <ng-content />
    @if (actions && showActions) {
      <pxc-action-buttons
        *showIfUserAuthorizedForSequence="sequence.sequenceInstance"
        optionButtonAppearance="flat-grayscale"
        optionButtonTheme="dark"
        tile-actions
        [actions]="actions"
        [entity]="sequence"
        [size]="'s'" />
    }
  </pxc-sequence-preview-tile-media-carousel>

  @if (showPatient) {
    <header
      [ngClass]="{
        'min-h-10': !isMobile,
      }">
      <pxc-sequence-patient-display
        [patient]="sequence.patientInstance"
        [patientId]="$safeNavigationMigration(sequence.patientInstance?.id)"
        [variant]="'compact'" />
    </header>
  }

  <p
    class="flex flex-wrap items-center gap-1 text-balance text-xs tracking-tight text-text-tertiary min-h-6 leading-none!">
    @let isByUser = sequence.sequenceInstance.creatorType === CreatorType.BY_USER;
    @let isByPatient = sequence.sequenceInstance.creatorType === CreatorType.BY_PATIENT;

    <span
      tuiHintDirection="top"
      [tuiHint]="
        t('{{ date }} à {{ time }}', {
          date: sequence.sequenceInstance.createdOn | date: 'mediumDate',
          time: sequence.sequenceInstance.createdOn | date: 'shortTime',
        })
      ">
      {{ sequence.sequenceInstance.createdOn | relativeDate }}
    </span>

    @if (isByUser && sequence.createdByInstance) {
      <span>{{ t('par') }}</span>
      <pxc-user-preview [colored]="false" [user]="sequence.createdByInstance" />
    }

    @if (isByPatient) {
      <pxc-sequence-review class="py-1" [compact]="true" [sequence]="sequence" />
    }
  </p>

  <!-- Labels -->
  <pxc-sequence-labels-list [isMobile]="isMobile" [labels]="sequence.labels" />
</ng-container>
